export const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
        {
            '@type': 'Question',
            name: 'Wie funktioniert Flip & Win?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Zieh einmal pro Tag eine Karte und gewinne mit etwas Glück kostenlose Credits oder tolle Preise wie Rabatte, Gutscheine oder Produkte deiner Lieblingsmarken im Pferdesport.',
            },
        },
        {
            '@type': 'Question',
            name: 'Wie oft kann ich spielen?',
            acceptedAnswer: {
                '@type': 'Answer',
                text: 'Du kannst einmal pro Tag kostenlos eine Karte ziehen.',
            },
        },
        {
            '@type': 'Question',
            name: 'Wann kann ich das nächste Mal spielen?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Neue Karten werden dir nach Ablauf von 24 Stunden angezeigt - komm also später wieder und versuch dein Glück erneut!',
            },
        },
        {
            '@type': 'Question',
            name: 'Was kann ich gewinnen?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Du kannst 5 bis 100 Credits, tolle Preise wie Rabatte, Gutscheine oder Produkte deiner Lieblingsmarken gewinnen oder leer ausgehen.',
            },
        },
        {
            '@type': 'Question',
            name: 'Was passiert, wenn ich gewinne?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Wenn Du Credits gewinnst, klicke auf die Schatfläche „Einlösen“, damit sie automatisch deinem Konto gutgeschrieben werden. Handelt es sich um einen Preis, also einen Rabatt, Gutschein oder ein Produkt, klicke auf die Schaltfläche „Ansehen“, um weitere Details zu erhalten.',
            },
        },
        {
            '@type': 'Question',
            name: 'Was passiert, wenn ich nichts gewinne?',
            acceptedAnswer: {
                '@type': 'Answer',
                text: 'Keine Sorge: Du verlierst nichts - versuch es einfach morgen erneut.',
            },
        },
        {
            '@type': 'Question',
            name: 'Muss ich bezahlen, um mitzumachen?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Nein. Das Karten-Spiel „Flip & Win“ ist komplett kostenlos und unverbindlich. Du musst jedoch ein aktives Mitglied sein. Um ein kostenloses Konto bei HorseDeal zu erstellen, besuche die Seite „Registrieren“.',
            },
        },
        {
            '@type': 'Question',
            name: 'Warum sehe ich ein Schloss auf der Karte?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Wenn Du das Karten-Spiel „Flip & Win“ heute bereits gespielt hast, sind die Karten bis morgen gesperrt und dein Countdown wird angezeigt. Du kannst dann wieder eine neue Karte ziehen. Stelle zudem sicher, dass Du in deinem Konto angemeldet bist. Um ein kostenloses Konto bei HorseDeal zu erstellen, besuche die Seite „Registrieren“.',
            },
        },
        {
            '@type': 'Question',
            name: 'Wo sehe ich meine gewonnen Credits?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Einen Überblick über deine gesammelten oder erworbenen Credits erhältst Du auf der Seite „Meine Bilanz“. Melde dich in deinem Konto an und klicke in der Navigation anschliessend auf „Meine Bilanz“. Gutschriften aus „Flip & Win“ werden mit dem Label „Bonus-Credits“ aufgeführt.',
            },
        },
        {
            '@type': 'Question',
            name: 'Kann ich schummeln oder öfter spielen?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Unser System erkennt Mehrfachversuche - bitte spiele fair und freue dich auf deine tägliche Chance!',
            },
        },
    ],
};
